
<template>
  <el-select
    :disabled="disabled"
    :multiple="multiple"
    :collapse-tags="collapse"
    :value="value.uID"
    filterable
    remote
    :placeholder="queryplace"
    clearable
    @input="change"
    @click.native="handleSelected()"
    :remote-method="remoteMethod"
  >
    <el-option
      v-for="item in userList"
      :key="item.uID"
      :label="`${item.uRealName}(${item.uLoginName})`"
      :value="item.uID"
    ></el-option>
    <div style="text-align: center">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="total"
        :page-size="size"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
  </el-select>
</template>

<script>
import { getUserListPage } from "../api/api";
export default {
  name: "UsersSelect",
  props: {
    value: {
      type: Object,
      default() {
        return {
          uID: "",
        };
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    collapse: {
      type: Boolean,
      default() {
        return false;
      },
    },
    queryplace: {
      type: String,
      default: function () {
        return "请选择人员";
      },
    },
  },
  data() {
    return {
      userList: [],
      userId: "",
      userSearch: "",
      total: 0,
      size: 20,
      page: 1,
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getUserInfoList();
    },
    handleSizeChange(val) {
      this.size = val;
      this.getUserInfoList();
    },
    remoteMethod(value) {
      this.userSearch = value.uRealName;
      this.getUserInfoList();
    },
    getUserInfoList() {
      let para = {
        size: this.size,
        page: this.page,
        key: this.userSearch,
      };
      getUserListPage(para).then((res) => {
        this.userList = res.data.response.data;
        this.total = res.data.response.dataCount;
        if(this.value && this.value.uID){
            let selected = this.userList.find(x=>x.uID==this.value.uID);
            if(!selected){
                this.userList.unshift({
                    uID: this.value.uID,
                    uRealName: this.value.uRealName,
                    uLoginName: this.value.uLoginName
                });
            }
        }
      });
    },
    change(val) {
      let selectedUser = this.userList.find((x) => x.uID == val);
      this.$emit("input", selectedUser);
    },
    // 按钮点击事件
    handleSelected() {
      // 主动触发点击事件
      this.userSearch = "";
      this.getUserInfoList();
    },
    check(val) {
      if (this.value != null) {
        var index = this.userList.findIndex((s) => s.uID == this.value);
        if (index < 0) {
          this.userSearch = val.uRealName;
          this.getUserInfoList();
        }
      }
    },
  },
  watch: {
    value: function (val) {
      this.check(val);
    },
  },
  mounted() {
    if (this.value) {
      this.userId = this.value.uID;
      if(this.value.uID){
        let selected = this.userList.find(x=>x.uID==this.value.uID);
        if(!selected){
            this.userList.unshift({
                uID: this.value.uID,
                uRealName: this.value.uRealName,
                uLoginName: this.value.uLoginName
            });
        }
      }
    }
    if (this.disabled) {
      this.disabled = this.disabled;
    }
    if (this.multiple) {
      this.multiple = this.multiple;
    }
    if (this.collapse) {
      this.collapse = this.collapse;
    }
  }
};
</script>